import React, { useState, useEffect } from 'react';

import { registerSupport } from '../../utils/firebase';

import CategoryImage1 from '../../assets/category-capitalism.png';
import CategoryImage2 from '../../assets/category-technology.png';
import CategoryImage3 from '../../assets/category-tendences.png';
import CategoryImage4 from '../../assets/category-labor.png';
import CategoryImage5 from '../../assets/category-social.png';

import './styles.css';
import './animation.css';

const categories = [
    {
        alias: 'capitalism',
        name: 'Capitalismo Consciente',
        image: CategoryImage1,
    },
    {
        alias: 'technology',
        name: 'Tecnologia Humanizada',
        image: CategoryImage2,
    },
    { alias: 'tendences', name: 'Tendências Globais', image: CategoryImage3 },
    { alias: 'labor', name: 'Futuro do Trabalho', image: CategoryImage4 },
    { alias: 'social', name: 'Mudança Social', image: CategoryImage5 },
];

const SupportModal = ({ category, setCategory, showModal, setShowModal }) => {
    const [name, setName] = useState('');
    const [answer, setAnswer] = useState('');
    const [answerSent, setAnswerSent] = useState(false);

    useEffect(() => {
        !showModal && setCategory(null);
    }, [showModal, setCategory]);

    useEffect(() => {
        const keyDownHandler = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();

                if (name && answer) {
                    setAnswerSent(true);
                    registerSupport(
                        categories.filter((c) => c.alias === category)[0].name,
                        name,
                        answer,
                    );

                    setTimeout(() => {
                        setAnswerSent(false);
                        setShowModal(false);
                    }, 3000);
                }
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [category, name, answer, setShowModal]);

    const currentCategory = categories.filter((c) => c.alias === category)[0];

    return (
        <div
            id='kes-support-modal'
            className={answerSent ? 'kes-modal-sent' : ''}
        >
            <div
                id='kes-modal-content'
                className={`kes-modal-category-${currentCategory.alias}`}
            >
                {!answerSent && (
                    <>
                        <button
                            id='kes-modal-return-button'
                            onClick={() => setShowModal(false)}
                        >
                            {'< voltar'}
                        </button>
                        <img
                            id='kes-modal-image'
                            src={currentCategory.image}
                            alt={currentCategory.name}
                        ></img>
                        <span className='kes-modal-text'>
                            Qual é o seu nome completo?
                        </span>
                        <input
                            className='kes-modal-input'
                            type='text'
                            placeholder='Seu nome aqui...'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <span className='kes-modal-text'>
                            Como eu posso contribuir/apoiar para que este
                            cenário desejável se torne mais possível no futuro?
                        </span>
                        <textarea
                            className='kes-modal-input'
                            placeholder='Sua resposta aqui...'
                            maxLength={300}
                            value={answer}
                            onChange={(e) => setAnswer(e.target.value)}
                        />
                        <button
                            id='kes-modal-send-button'
                            className={
                                !name || !answer ? 'kes-button-disabled' : ''
                            }
                            onClick={() => {
                                if (name && answer) {
                                    setAnswerSent(true);
                                    registerSupport(
                                        currentCategory.name,
                                        name,
                                        answer,
                                    );

                                    setTimeout(() => {
                                        setAnswerSent(false);
                                        setShowModal(false);
                                    }, 3000);
                                }
                            }}
                        >
                            compartilhar resposta
                        </button>
                    </>
                )}
                {answerSent && (
                    <>
                        <div id='kes-modal-sent-message'>
                            <span>resposta enviada com sucesso</span>
                        </div>
                        <div id='kes-modal-sent-message-square'></div>
                    </>
                )}
            </div>
        </div>
    );
};

export default SupportModal;
